var StaticPages;

StaticPages = window.StaticPages != null ? window.StaticPages : window.StaticPages = {};

StaticPages.init = function(arg, done) {
  var isResponsive, isTouchRequest, staticPageArray, staticPages;
  staticPages = arg.staticPages;
  if (!staticPages) {
    return done();
  }
  staticPageArray = staticPages.staticPageArray, isTouchRequest = staticPages.isTouchRequest, isResponsive = staticPages.isResponsive;
  if (!(staticPageArray != null ? staticPageArray.length : void 0)) {
    return done();
  }
  return $(function() {
    var $body, $main, $pitch, deferreds;
    if (isTouchRequest) {
      $body = $('body');
      $main = $('div.t-main');
      $pitch = $(isResponsive ? '.t-pod.toggle-drawer.highlights' : '#about-deal');
    } else {
      $pitch = $('article.pitch');
    }
    deferreds = $.map(staticPageArray, function(arg1) {
      var $staticPage, $staticPageOpener, formattedAjaxUrl, staticPageHref, staticPageId, staticPageType;
      staticPageType = arg1.staticPageType, staticPageId = arg1.staticPageId, staticPageHref = arg1.staticPageHref, formattedAjaxUrl = arg1.formattedAjaxUrl;
      $staticPage = $("#" + staticPageId);
      $staticPageOpener = $pitch.find("a[href='" + staticPageHref + "']");
      if (!($staticPage.length && $staticPageOpener.length)) {
        return;
      }
      return $.ajax({
        url: formattedAjaxUrl,
        dataType: 'json',
        success: function(res) {
          var $bodyHtml, bodyHtml, title;
          bodyHtml = res.bodyHtml, title = res.title;
          if (staticPageType === 'articles') {
            bodyHtml = res.content;
          }
          if (!((bodyHtml != null ? bodyHtml.length : void 0) && (title != null ? title.length : void 0))) {
            return;
          }
          if (isTouchRequest) {
            $staticPage.find('header.t-header h2').text(title);
            $bodyHtml = $staticPage.find('div.t-body-html').html(bodyHtml);
            if (!isResponsive) {
              $bodyHtml.find(':contains("Jump to..")').remove();
              $bodyHtml.find('a[href]').parent().remove();
            }
            $staticPage.find('a.t-back-link').off().click(function() {
              $staticPage.hide();
              return $main.show();
            });
            $staticPage.find('a.t-pane-back-to-top').click(function() {
              return $body.animate({
                scrollTop: 0
              }, 'median');
            });
            return $staticPageOpener.click(function() {
              $main.hide();
              $staticPage.show();
              $body.animate({
                scrollTop: 0
              }, 'slow');
              return false;
            });
          } else {
            $staticPage.find('h2.section-title').text(title);
            return $staticPage.find('div.body-html').html(bodyHtml);
          }
        },
        error: function(err) {
          if (!isTouchRequest) {
            $staticPageOpener.removeAttr('data-modal-id');
          }
          $staticPageOpener.off();
          return $staticPage.remove();
        }
      });
    });
    return $.when.apply($, deferreds).then(done);
  });
};

module.exports = StaticPages;

//# sourceMappingURL=data:application/json;base64,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
